// sl-i18n.js — Store Locator Multi-Language Patch (EN + FR)
// Temporary patch until native i18n is released by Rose Perl Technology
// Usage: Upload to Shopify theme Assets, then add to theme.liquid before </head>:
//   <script src="{{ 'sl-i18n.js' | asset_url }}" defer></script>

(function () {
  var TRANSLATIONS = {
    'en': {
      // Page & search area
      page_title: 'Store Locator',
      curr_loc_text: 'Current Location',
      enter_a_location_text: 'Enter a location',
      radius_text: 'Search Radius',
      msr_text: 'Search Radius Measurement',
      find_loc_btn_text: 'Find My Location',
      search_btn_text: 'Search',
      filter_tags_text: 'Filter by Tags',
      no_limit_text: 'No Limit',
      // Distance units
      miles_text: 'Mile',
      kilometers_text: 'Kilometer',
      kilometer_unit_text: 'Kilometer',
      // Map/list tabs
      map_text: 'Map',
      list_text: 'List',
      view_map_btn_text: 'View Map',
      // Show more/less
      more_text: 'More',
      less_text: 'Less',
      // Directions
      direction_text: 'Get Directions',
      // No results
      no_result_title: 'No results',
      no_result_tags: 'No stores found near this location.',
      // Location disabled alert
      location_is_disabled_alert: 'Location Services Disabled',
      location_is_disabled_text: 'Please turn on device location to use Find My Location',
      // Operating hours
      open_text: 'Open',
      open_now_text: 'Open now',
      opens_text: 'Opens',
      closed_text: 'Closed',
      closes_text: 'Closes',
      closes_soon_text: 'Closes soon',
      // Days
      monday_text: 'Monday',
      tuesday_text: 'Tuesday',
      wednesday_text: 'Wednesday',
      thursday_text: 'Thursday',
      friday_text: 'Friday',
      saturday_text: 'Saturday',
      sunday_text: 'Sunday',
      monday_acronym_text: 'Mon',
      tuesday_acronym_text: 'Tue',
      wednesday_acronym_text: 'Wed',
      thursday_acronym_text: 'Thu',
      friday_acronym_text: 'Fri',
      saturday_acronym_text: 'Sat',
      sunday_acronym_text: 'Sun',
    },
    'fr': {
      // Page & search area
      page_title: 'N\'hésitez pas à nous rendre visite / Localisateur de la boutique Beanbag Montréal',
      curr_loc_text: 'Emplacement actuel',
      enter_a_location_text: 'Entrez une adresse',
      radius_text: 'Rayon de recherche',
      msr_text: 'Unité de mesure',
      find_loc_btn_text: 'Me localiser',
      search_btn_text: 'Rechercher',
      filter_tags_text: 'Filtrer par tags',
      no_limit_text: 'Sans limite',
      // Distance units
      miles_text: 'Mille',
      kilometers_text: 'Kilomètre',
      kilometer_unit_text: 'Kilomètre',
      // Map/list tabs
      map_text: 'Carte',
      list_text: 'Liste',
      view_map_btn_text: 'Voir la carte',
      // Show more/less
      more_text: 'Plus',
      less_text: 'Moins',
      // Directions
      direction_text: 'Obtenir l\'itinéraire',
      // No results
      no_result_title: 'Aucun résultat',
      no_result_tags: 'Aucun magasin trouvé près de cet endroit.',
      // Location disabled alert
      location_is_disabled_alert: 'Services de localisation désactivés',
      location_is_disabled_text: 'Veuillez activer la localisation de votre appareil pour utiliser Me localiser',
      // Operating hours
      open_text: 'Ouvert',
      open_now_text: 'Ouvert maintenant',
      opens_text: 'Ouvre',
      closed_text: 'Fermé',
      closes_text: 'Ferme',
      closes_soon_text: 'Ferme bientôt',
      // Days
      monday_text: 'Lundi',
      tuesday_text: 'Mardi',
      wednesday_text: 'Mercredi',
      thursday_text: 'Jeudi',
      friday_text: 'Vendredi',
      saturday_text: 'Samedi',
      sunday_text: 'Dimanche',
      monday_acronym_text: 'Lun',
      tuesday_acronym_text: 'Mar',
      wednesday_acronym_text: 'Mer',
      thursday_acronym_text: 'Jeu',
      friday_acronym_text: 'Ven',
      saturday_acronym_text: 'Sam',
      sunday_acronym_text: 'Dim',
    }
  };

  function detectLocale() {
    var path = window.location.pathname;
    var hash = window.location.hash;
    var params = new URLSearchParams(window.location.search);

    // 1. URL path: /fr/pages/... or /fr-fr/pages/...
    if (/^\/(fr|fr-fr|fr-be|fr-ca)(\/|$)/i.test(path)) return 'fr';
    if (/^\/(en|en-us|en-gb|en-ca)(\/|$)/i.test(path)) return 'en';

    // 2. URL hash: #fr
    if (/^#(fr|fr-fr)/i.test(hash)) return 'fr';

    // 3. Query param: ?lang=fr
    var lang = params.get('lang') || '';
    if (/^fr/i.test(lang)) return 'fr';

    // 4. Shopify.locale
    if (typeof Shopify !== 'undefined' && Shopify.locale) {
      if (/^fr/i.test(Shopify.locale)) return 'fr';
    }

    // 5. HTML lang attribute
    var htmlLang = document.documentElement.lang || '';
    if (/^fr/i.test(htmlLang)) return 'fr';

    return 'en'; // default
  }

  // Hardcoded strings not in SCASLSetting — require DOM patching
  var DOM_LABELS = {
    'en': {
      phone_label: 'Phone Number',
      email_label: 'Email',
      operating_hours_label: 'Operating Hours',
    },
    'fr': {
      phone_label: 'Numéro de téléphone',
      email_label: 'Courriel',
      operating_hours_label: 'Heures d\'ouverture',
    }
  };

  function applyTranslations(translations) {
    if (typeof SCASLSetting === 'undefined') return false;
    Object.assign(SCASLSetting, translations);
    return true;
  }

  // Replace hardcoded DOM text that can't be set via SCASLSetting
  // Guard: only replace if text hasn't been translated yet (prevents infinite loop)
  function patchDomLabels(labels) {
    if (labels.phone_label) {
      document.querySelectorAll('#scasl-phone-label').forEach(function (el) {
        if (el.textContent !== labels.phone_label) el.textContent = labels.phone_label;
      });
    }
    if (labels.email_label) {
      document.querySelectorAll('#scasl-email-label').forEach(function (el) {
        if (el.textContent !== labels.email_label) el.textContent = labels.email_label;
      });
    }
    if (labels.operating_hours_label) {
      document.querySelectorAll('#scasl-operating-hours-label').forEach(function (el) {
        if (el.textContent !== labels.operating_hours_label) el.textContent = labels.operating_hours_label;
      });
    }
  }

  // Watch for dynamically rendered store cards and popups
  function observeDom(labels) {
    var container = document.querySelector('#scasl-app-container') || document.body;
    var observer = new MutationObserver(function () {
      patchDomLabels(labels);
    });
    observer.observe(container, { childList: true, subtree: true });
    // Also patch anything already in DOM on load
    patchDomLabels(labels);
  }

  function init() {
    var locale = detectLocale();
    var translations = TRANSLATIONS[locale] || TRANSLATIONS['en'];
    var domLabels = DOM_LABELS[locale] || DOM_LABELS['en'];

    // Retry up to 50 times (~5 seconds) waiting for SCASLSetting to load
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (applyTranslations(translations)) {
        clearInterval(interval);
      } else if (attempts >= 50) {
        clearInterval(interval);
        console.warn('[sl-i18n] SCASLSetting not found after 50 attempts. Patch not applied.');
      }
    }, 100);

    // DOM patching runs independently (hardcoded strings)
    if (locale !== 'en') {
      observeDom(domLabels);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
